import { render, staticRenderFns } from "./UserInteractor.vue?vue&type=template&id=788164da&lang=pug&"
import script from "./UserInteractor.vue?vue&type=script&lang=ts&"
export * from "./UserInteractor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports